import { axiosInstance } from "@/helper/axios-instance";
import type { StockPriceRegister, DataAwareResponse } from "../types/types";
import { useMutationWithValidation } from "./useMutationWithValidation";

export function useStockPriceRegisterCreation(id: string) {
  return useMutationWithValidation({
    mutationFn: async (data: Partial<StockPriceRegister>) => {
      const response = await axiosInstance({
        method: "POST",
        url:  `StockPriceRegister/insert?id=${id}`,
        data: data,
      });

      return response.data as DataAwareResponse<StockPriceRegister>;
    },
    retry: 2,
    customMessage: {
      success: "Stock price register created successfully",
    },
  });
}
